import React, { useEffect, useState } from 'react';
import IconoTitulo from '../UI/IconoTitulo.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import { encontrarIdNumber } from '../funciones/FuncionesArray.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './Selecciones.module.css';
import { ArmarListaTorneosAgrupacion } from '../funciones/FuncionesTorneos.js';

const TorneosSeleccion = (props) => {
  const idPais = props.idPais;
  const codCategoria = props.categoria ? props.categoria.codigo : null;
  const codAgrupacion = props.agrupacion ? props.agrupacion.codigo : null;
  const codTipoTorneo = props.tipoTorneo ? props.tipoTorneo.codigo : null;
  const [torneos, setTorneos] = useState(null);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const armarListaTorneos = (lista) => {
      setTorneos(ArmarListaTorneosAgrupacion(lista));
    };

    if (idPais === null) {
      setTorneos(null);
    } else {
      let filtros = '';
      if (codCategoria) {
        filtros += '&categoria=' + codCategoria;
      }
      if (codAgrupacion) {
        filtros += '&agrupacion=' + codAgrupacion;
      }
      if (codTipoTorneo) {
        filtros += '&tipo=' + codTipoTorneo;
      }
      if (filtros !== '') {
        filtros = '?' + filtros.slice(1);
      }
      fetchData('selecciones_pais/' + idPais + '/torneos' + filtros, armarListaTorneos);
    }
  }, [fetchData, idPais, codCategoria, codAgrupacion, codTipoTorneo]);

  const onClickHandler = (event) => {
    let torneoElegido = encontrarIdNumber(torneos, event.target.id);
    if (torneoElegido === null) {
      alert('No se encontró el torneo elegido');
    } else {
      props.onTorneoElegido(torneoElegido);
    }
  };

  return (
    <div className={`${styles.cuadroTorneos}`}>
      <span className={`${styles.tituloCuadroDatos}`}>Torneos</span>
      {torneos && !isCargando && (
        <React.Fragment>
          {torneos.length > 0 && (
            <table className={`${styles.tablaDatos}`}>
              <tbody>
                {torneos.map((torneo) => (
                  <tr key={torneo.id}>
                    <td>
                      <button
                        className={`${styles.botonTorneo}`}
                        key={torneo.id}
                        id={torneo.id}
                        onClick={onClickHandler}
                      >
                        {torneo.descripcion}
                        <IconoTitulo objeto={torneo} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </React.Fragment>
      )}
      <MensajeCargando estilo={`${styles.cargando}`} isCargando={isCargando} />
      <MensajeError estilo={`${styles.error}`} errores={erroresGetLista} />
    </div>
  );
};

export default TorneosSeleccion;
